import React from "react";
import { SettlementsTable } from "../components/SettlementsTable";
import { useAgreementContext } from "../AgreementContext";
import { Stack } from "@mui/material";

const SettlementsPage = () => {
  const agreement = useAgreementContext();
  return (
    <Stack spacing={5} sx={{ px: 5, mb: 5 }}>
      <SettlementsTable agreement={agreement} />
    </Stack>
  );
};

export default SettlementsPage;
